import { Row, Col, Form, FormCheck } from "react-bootstrap";
import Select from "react-select";
const PlaylistsFileIdent = (
  programDetails,
  setProgramDetails,
  setFormEdited,
  identsLoading,
  identsError,
  allIdentsData,
  graphics,
  isLocked
) => {
  return (
    <Form.Group controlId="preRollFileIdentInput">
      <Row className="align-items-center pt-2 ">
        <Form.Label
          column
          xs="2"
        >
          File Ident:
        </Form.Label>
        <Col sm="9">
          <Form.Select
            value={programDetails.preRoll.file.ident.ident}
            size="sm"
            onChange={(e) => {
              setProgramDetails({
                ...programDetails,
                preRoll: {
                  ...programDetails.preRoll,
                  file: {
                    ...programDetails.preRoll.file,
                    ident: {
                      ...programDetails.preRoll.file.ident,
                      ident: e.target.value,
                      isDirty: true,
                    },
                  },
                },
              });
              setFormEdited(true);
            }}
            className={
              programDetails.preRoll.file.ident.isDirty && "text-danger"
            }
            disabled={isLocked}
          >
            <option value="">Select an ident</option>
            {identsLoading ? (
              <option>Loading...</option>
            ) : identsError ? (
              <option>Error loading idents</option>
            ) : (
              allIdentsData &&
              allIdentsData.map((ident) => (
                <option
                  key={ident._id}
                  value={ident._id}
                >
                  {ident.name}
                </option>
              ))
            )}
          </Form.Select>
        </Col>
        <Col sm="1">
          <FormCheck
            type="checkbox"
            isValid
            checked={programDetails.preRoll.file.ident.isDirty}
            onChange={(e) => {
              setProgramDetails({
                ...programDetails,
                preRoll: {
                  ...programDetails.preRoll,
                  file: {
                    ...programDetails.preRoll.file,
                    ident: {
                      ...programDetails.preRoll.file.ident,
                      isDirty: e.target.checked,
                    },
                  },
                },
              });
              setFormEdited(true);
            }}
            disabled={isLocked}
          />
        </Col>
      </Row>
      <Row className="pt-2 mt-2  border-0 border-top align-items-center">
        <Col
          // column
          xs={2}
        >
          Graphics:
        </Col>
        <Col>
          <Select
            name="file.graphics"
            size="sm"
            isMulti
            closeMenuOnSelect={false}
            options={graphics}
            value={programDetails.preRoll.file.graphics.graphics}
            className={
              programDetails.preRoll.file.graphics.isDirty && "text-danger"
            }
            onChange={(e) => {
              setProgramDetails({
                ...programDetails,
                preRoll: {
                  ...programDetails.preRoll,
                  file: {
                    ...programDetails.preRoll.file,
                    graphics: {
                      ...programDetails.preRoll.file.graphics,
                      graphics: e,
                      isDirty: true,
                    },
                  },
                },
              });
              setFormEdited(true);
            }}
            isDisabled={isLocked}
          />
        </Col>
        <Col sm="1">
          <FormCheck
            type="checkbox"
            isValid
            checked={programDetails.preRoll.file.graphics.isDirty}
            onChange={(e) => {
              setProgramDetails({
                ...programDetails,
                preRoll: {
                  ...programDetails.preRoll,
                  file: {
                    ...programDetails.preRoll.file,
                    graphics: {
                      ...programDetails.preRoll.file.graphics,
                      isDirty: e.target.checked,
                    },
                  },
                },
              });
              setFormEdited(true);
            }}
            disabled={isLocked}
          />
        </Col>
      </Row>
    </Form.Group>
  );
};
export default PlaylistsFileIdent;
